<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)"   size="large"   color="#0058ff"  type="ball-scale-pulse"  [fullScreen]="true">
  <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
    <div class="col-md-12">
      
        <div class="row">
            <div class="card">
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">โควตาชาวไร่ 10 หลัก</span>
                    <input type="text" class="form-control" placeholder="รหัส10หลัก" (keypress)="numberOnly($event)" [(ngModel)]="fmcode">
                    <button class="btn-sm btn-primary" (click)="Findqueuetdata();">ค้นหา</button>
                  </div>
                <div class="card-body">
                    <table class="table" #table>
                        <thead>
                            <tr>
                                <td>เลขใบคิว</td>
                                <td>เลขแปลง</td>
                                <td>ประเภทคิว/ลานส่ง</td>
                                <td>วันที่</td>
                                <td>อ้อยเข้า</td>
                                <td>ประมาณค่าอ้อย</td>
                                <td>CCS</td>
                                <td>แก้ไขข้อมูลอ้อย</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let it of queuedata">
                                <td> {{it.truck_q}}</td>  
                                <td>{{it.landno}}</td>
                                <td>{{it.truck_desc}}</td>
                                <td>{{it.reportdate_th}}</td>
                                <td>{{it.wgt_net}}</td>
                                <td>{{it.cane_amt}}</td>
                                <td>{{it.ccs_value}}</td>
                                <td><button class="btn btn-warning" (click)="chosedata(it.truck_q)">แก้ไขแปลง</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">แก้ไขหมายเลขแปลงอ้อยเข้า</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  (click)="closemodal();"></button>
        </div>
        <div class="modal-body" *ngFor="let item of onedata">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12"> 
                        <b>ข้อมูลแปลงเดิม</b>
                        <p>เลขที่ใบคิว : {{item.truck_q}}</p>
                        <p>เลขแปลง : {{item.landno}}</p> 
                        <p>อ้อยเข้า : {{item.ccs_value}}</p> 

                        <p> เปลี่ยนเป็น :</p>
                        <div class="input-group mb-6">
                            <span class="input-group-text" id="basic-addon1">หมายเลขแปลง</span>
                            <select class="form-select"  [(ngModel)]="changeitid">
                                <option value="00" selected disabled>-- กรุณา เลือก --</option>
                                <option *ngFor="let item of plantdata" [ngValue]="[item.itid,item.intlandno]">
                                    {{item.intlandno}}
                                </option>
                            </select>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closemodal();">Close</button>
          <button type="button" class="btn btn-primary" (click)="updateData();">บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>